import React from 'react'
import Bredcrum from '../../common/Bredcrum'

const RefundDelivery = () => {
    return (
        <>

            <Bredcrum
                heading={'Refund Policy'}
                path={[
                    { name: 'Refund Policy', path: 'refund-and-Delivery' },
                ]}
            />  

            <div className=' my-5 pb-md-5 common-list-container'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row">
                        <div className="sec-title">
                            <div className="card-body">
                                <h4 className="text-uppercase mb-4">
                                    <strong className='text-black'>Refund Policy</strong>
                                </h4>
                                <ol className='ps-0'>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>1. Cancellation Policy</h5>
                                        <div className='ms-3 ps-1' >

                                            If you wish to cancel your booking, you must inform Precision Driving
                                            School Limited at least 48 hours prior to your scheduled lesson.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>2. Refunds</h5>
                                        <div className='ms-3 ps-1'>
                                            a) For cancellations made with a notice of 48 hours or more, a full refund
                                            will be provided.
                                            <br />
                                            b) For cancellations made with less than 48 hours notice, 50% of the
                                            lesson fee will be refunded.
                                            <br />
                                            c) If Precision Driving School Limited has to cancel a lesson for any
                                            reason, a full refund or an option to reschedule will be provided.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>3. No-Shows</h5>

                                        <div className='ms-3 ps-1'>
                                            If a student fails to show up for a scheduled lesson without prior notice,
                                            no refund will be provided.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>4. Package Refunds</h5>

                                        <div className='ms-3 ps-1'>
                                            For packages that include multiple lessons, refunds will be calculated
                                            based on the number of lessons already taken, minus a 10% administrative
                                            fee. Unused lessons will be refunded in full.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>5. Refund Processing</h5>

                                        <div className='ms-3 ps-1'>
                                            All refunds will be processed within 10 business days and returned via the
                                            original method of payment.
                                        </div>
                                    </li>
                                </ol>

                                <h4 className="text-uppercase mb-4 mt-5">
                                    <h5 className='text-black'>Delivery Policy</h5>
                                </h4>
                                <ol className='ps-0'>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>1. Lesson Timing</h5>
                                        <div className='ms-3 ps-1'>
                                            Students are advised to arrive at least 10 minutes prior to the scheduled
                                            lesson time. If late, the time missed will be deducted from the lesson
                                            duration.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>2. Location</h5>
                                        <div className='ms-3 ps-1'>
                                            Lessons will start and end at the location agreed upon at the time of
                                            booking. Any changes should be communicated at least 24 hours in advance.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>3. Vehicle Provided</h5>
                                        <div className='ms-3 ps-1'>
                                            Precision Driving School Limited will provide a well-maintained, insured,
                                            and road-worthy vehicle for all driving lessons.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>4. Instructor Allocation</h5>
                                        <div className='ms-3 ps-1'>
                                            While we do our best to accommodate instructor preferences, we cannot
                                            guarantee the same instructor for all lessons. However, all our
                                            instructors are certified and experienced.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>5. Rescheduling</h5>
                                        <div className='ms-3 ps-1'>
                                            If you need to reschedule, inform us at least 48 hours in advance to avoid
                                            any charges. Rescheduling with less than 48 hours notice will incur a 25%
                                            rescheduling fee.
                                        </div>
                                    </li>
                                    <li className='mb-4'>
                                        <h5 className='d-block text-black mb-1'>6. Package Delivery</h5>
                                        <div className='ms-3 ps-1'>
                                            For students who purchase multiple lesson packages, lessons should be
                                            scheduled and completed within 6 months of purchase. Any lessons not used
                                            within this timeframe will be forfeited.
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default RefundDelivery